import React, { useEffect } from 'react';
import { Controller, useForm } from "react-hook-form";
import { MdOutlineClose, MdOutlineSave } from 'react-icons/md';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { adjustToNoon } from "helpers/utils";
import { Modal, Button, FormRow } from 'components/common';

import { INPUT_CLS } from 'helpers/formStyles';
const PeriodForm = ({ open, setOpen, record, title, onSave }) => {
  const { control, handleSubmit, formState: { errors }, setValue } = useForm();

  useEffect(() => {
    setValue('status', 'open'); // Default to 'Open'

    if (record) {
      Object.entries(record).forEach(([key, value]) => {
        switch (key) {
          case 'start_date':
          case 'end_date':
            value = value ? new Date(value) : null;
            break;
          default:
            break;
        }
        setValue(key, value);
      })
    }
  }, [setValue, record, open]);

  const onSubmit = async (data) => {
    try {
      await onSave(data);
      handleClose();
    } catch (error) {
      toast.error(error.message);
    }
  }

  const handleClose = () => setOpen(false);

  const statusOpenOptions = [
    { value: 'open', label: 'Open' },
    { value: 'closed', label: 'Closed' }
  ];

  return (
    <Modal
      show={open}
      onHide={handleClose}
      backdropClick={false}
      title={title}
      footer={
        <div className="tw-flex tw-justify-end tw-gap-2">
          <Button variant="danger" size="sm" leftIcon={MdOutlineClose} onClick={handleClose}>Close</Button>
          <Button variant="primary" size="sm" leftIcon={MdOutlineSave} onClick={handleSubmit(onSubmit)}>
            {record ? "Update" : "Save"}
          </Button>
        </div>
      }
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormRow label="Start date" required error={errors.start_date?.message}>
          <Controller
            control={control}
            name="start_date"
            rules={{ required: "Start date is required" }}
            render={({ field }) => (
              <DatePicker
                selected={field.value}
                onChange={(date) => field.onChange(adjustToNoon(date))}
                className={INPUT_CLS}
                placeholderText="dd-MMM-YYYY"
                dateFormat="dd-MMM-yyyy"
                fixedHeight
                todayButton="Today"
              />
            )}
          />
        </FormRow>

        <FormRow label="End date" required error={errors.end_date?.message}>
          <Controller
            control={control}
            name="end_date"
            rules={{ required: "End date is required" }}
            render={({ field }) => (
              <DatePicker
                selected={field.value}
                onChange={(date) => field.onChange(adjustToNoon(date))}
                className={INPUT_CLS}
                placeholderText="dd-MMM-YYYY"
                dateFormat="dd-MMM-yyyy"
                fixedHeight
                todayButton="Today"
              />
            )}
          />
        </FormRow>

        <FormRow label="Status" error={errors.status?.message}>
          <Controller
            control={control}
            name="status"
            render={({ field }) => (
              <Select
                {...field}
                options={statusOpenOptions}
                value={statusOpenOptions.find(option => option.value === field.value)}
                placeholder="Select..."
                classNamePrefix="react-select"
                onChange={(selectedOption) => field.onChange(selectedOption.value)}
              />
            )}
          />
        </FormRow>
      </form>
    </Modal>
  )
}

PeriodForm.propTypes = {
  open: PropTypes.bool.isRequired,
  record: PropTypes.object,
  title: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  setOpen: PropTypes.func.isRequired
}

export default PeriodForm;
